export default [{"id":"1","startTime":0,"endTime":4331,"text":"<b>Click on the monitor to watch an informative</b>\n<b>video about Busch-Jaeger.</b>"}];